import {
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ProductInsertUpdateModal from "./ProductInsertUpdateModal";
import { getProductApi, deleteProductApi } from "src/api/productApi";
import DataTable from "react-data-table-component";
import { DeleteSharp, EditSharp } from "@mui/icons-material";
import Deletemodal from "src/pages/DeleteModal";
import { notification } from "src/utils/messages";

export default function Index() {
  const [addEditModal, setAddEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState({ mval: false, id: 0 });
  const [modalType, setModalType] = useState("Add");
  const [productData, setProductData] = useState([]);
  const [page, setPage] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const getProductMethod = async () => {
    const resp = await getProductApi({ i_p_type: -1 });
    if (resp.status == 1) {
      setProductData(resp?.data);
    }
  };

  const deleteProductMethod = async () => {
    const resp = await deleteProductApi({
      i_p_id: rowData.i_p_id
    });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status) getProductMethod();
    setOpenDeleteModal({ mval: false, id: 0 });
  };

  useEffect(() => {
    getProductMethod();
  }, []);

  const columns = [
    {
      name: "No",
      selector: (row, index) => (page - 1) * rowsPerPage + index + 1,
      wrap: true,
      width: "70px",
      sortable: false
    },
    {
      name: "Product Name",
      wrap: true,
      selector: (row) => row.i_p_name,
      sortable: true,
      width: "150px"
    },
    {
      name: "Product Price",
      wrap: true,
      selector: (row) => row.i_p_price,
      sortable: true,
      width: "150px"
    },
    {
      name: "HSN/SAC Code",
      wrap: true,
      selector: (row) => row.i_hsn_code,
      sortable: true,
      width: "150px"
    },
    {
      name: "Product Type",
      wrap: true,
      selector: (row) => <span>{row.i_p_type == 0 ? "Normal Product" : "Membership Product"}</span>,
      sortable: true,
      width: "200px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          {row?.editable == 1 && (
            <>
              <Tooltip title="Edit Product">
                <IconButton
                  onClick={() => {
                    setModalType("Edit");
                    setRowData(row);
                    toggleAddEditModal();
                  }}
                >
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Product">
                <IconButton
                  onClick={() => {
                    setRowData(row);
                    setOpenDeleteModal({
                      mval: true,
                      id: row.i_p_id
                    });
                  }}
                >
                  <DeleteSharp color="error" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )
    }
  ];

  const ExpandedComponent = ({ data }) => (
    <div style={{ padding: "12px 16px", background: "#f9fafb" }}>
      <strong>Description:</strong>
      <div>{data.i_d_description}</div>
    </div>
  );

  return (
    <>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Product
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => {
                toggleAddEditModal();
                setModalType("Add");
              }}
              style={{ marginBottom: "15px", float: "right" }}
              variant="contained"
            >
              {/* Add Product */}
              Add Product
            </Button>
          </Grid>
        </Grid>

        <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            pagination
            highlightOnHover
            paginationServer={false}
            onChangePage={(p) => setPage(p)}
            paginationDefaultPage={page}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(newPerPage, page) => {
              setRowsPerPage(newPerPage);
              setPage(page);
            }}
            columns={columns}
            data={productData != null ? productData : []}
            expandableRows
            expandOnRowClicked
            expandableRowsComponent={ExpandedComponent}
            expandableRowDisabled={(row) => !row?.i_d_description}
          />
        </Card>
      </Container>
      {addEditModal && (
        <ProductInsertUpdateModal
          addEditModal={addEditModal}
          setAddEditModal={setAddEditModal}
          modalType={modalType}
          toggleAddEditModal={toggleAddEditModal}
          rowData={rowData}
          getProductMethod={getProductMethod}
        />
      )}

      <Deletemodal
        visible={openDeleteModal}
        setVisible={setOpenDeleteModal}
        deletefunc={deleteProductMethod}
      />
    </>
  );
}
